import '../style/css/leftmenu.css';
import TranslationButton from '../scheleton/components/TranslationButton';

const TopBar = (props) => {
    return (
        <>
        <div className="row darker-bg   " >
                <div className="col-12 align-right  margin-right1">
                    <TranslationButton></TranslationButton>
                </div>

        </div>

        </>
    )
; }

export default TopBar